import { Box, Grid } from '@mui/material';
import { WsTitleBanner } from 'wisestep-base';

import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';

import FAQIndex from './FAQIndex';

interface IJobBoard {
  children: React.ReactElement;
}

const FAQDetailsPage = ({ children }: IJobBoard) => {
  return (
    <Box>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.HELP_AND_KNOWLEDGE,
          Pages['FREQUENTLY_ASKED_QUESTIONS']
        )}
      />
      <WsTitleBanner title="Frequently Asked Questions" backButton={false} />
      <Grid container rowGap={3}>
        <Grid item xs={3}>
          <FAQIndex />
        </Grid>
        <Grid item xs={9} pt={3}>
          {children}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FAQDetailsPage;
